import { PIRL } from '../types';
export default {
  type: PIRL,
  service: 'pirl.io',
  url: 'https://wallrpc.pirl.io',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
